import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoSearch } from "react-icons/io5";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { Table, Pagination } from "react-bootstrap";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import sort from "../../assets/sort.svg";
import filter from "../../assets/filter.svg";
import ToastMsg from "../../component/comman/ToastMsg";
import { dashboardList } from "../../services/ApiServices";
import moment from 'moment';
import { GoEyeClosed } from "react-icons/go";

function Dashboard() {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [summary, setSummary] = useState([]);
  const [hideOne, setHideOne] = useState(() => {
    const storedValue = localStorage.getItem('hideOne');
    return storedValue === 'true' ? true : false;
  });
  const [hideTwo, setHideTwo] = useState(() => {
    const storedValue = localStorage.getItem('hideTwo');
    return storedValue === 'true' ? true : false;
  });
  const [hideThree, setHideThree] = useState(() => {
    const storedValue = localStorage.getItem('hideThree');
    return storedValue === 'true' ? true : false;
  });
  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  const getCustomersDetails = useCallback(
    (params = {}) => {
      const queryParams = { ...params, filter_value: searchTerm, page_num: currentPage, per_page_data: itemsPerPage };
      dashboardList(queryParams)
        .then((res) => {
          console.log("API Response:", res.data.data);
          if (res.status === 200 && Array.isArray(res?.data?.data)) {
            setSummary(res?.data?.transaction_summary)
            setCustomers(res?.data?.data);
            setFilteredCustomers(res?.data?.data);
            setPageInfo(res?.data?.page_info);
            setTotalPages(res?.data?.page_info.total_pages);
          } else {
            setCustomers([]);
            setFilteredCustomers([]);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          if (err.response?.status === 401) {
            navigate("/");
          }
          let error = err?.response?.data?.error || "something went wrong";
          ToastMsg(error, "error");
          setCustomers([]);
          setFilteredCustomers([]);
        });
    },
    [navigate, searchTerm, currentPage, itemsPerPage]
  );
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCustomersDetails();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, getCustomersDetails]);

  useEffect(() => {
    setFilteredCustomers(customers);
    setTotalPages(Math.ceil(customers.length / itemsPerPage));
  }, [customers, itemsPerPage]);

  const handleSort = (sortOrder) => {
    const params = { order: sortOrder };
    getCustomersDetails(params);
  };
  
  const handleAccounts = (sortOrder) => {
    const params = { transaction_type: sortOrder };
    getCustomersDetails(params);
  };

  useEffect(() => {
    getCustomersDetails();
  }, [currentPage, itemsPerPage, getCustomersDetails]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <>
      <div className="dasboard-content">
        <div className="card mb-4">
          <div className="card-body">
            <div className="search-sc d-flex align-items-center justify-content-between">
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <IoSearch className="search-icon" />
                </div>
              </form>
            </div>
            <div className="cr-dr">
              <div className="row">
                <div className="colm green">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Debit <TiArrowSortedDown />
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideOne((hideOne) => {
                        const newValue = !hideOne;
                        localStorage.setItem('hideOne', newValue.toString());
                        return newValue;
                      });
                    }}/>
                  </div>
                  <h2 className={hideOne ? "active" : ""}>€ {summary?.total_debit}</h2>
                </div>
                <div className="colm red">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Credit <TiArrowSortedUp/>
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideTwo((hideTwo) => {
                        const newValue = !hideTwo;
                        localStorage.setItem('hideTwo', newValue.toString());
                        return newValue;
                      });
                    }}/>
                  </div>
                  <h2 className={hideTwo ? "active" : ""}>€ {summary?.total_credit}</h2>
                </div>
                <div className="colm blue">
                  <div className="d-flex align-items-center justify-content-between">
                    <p>Balance</p>
                    <GoEyeClosed onClick={() => {
                      setHideThree((hideThree) => {
                        const newValue = !hideThree;
                        localStorage.setItem('hideThree', newValue.toString());
                        return newValue;
                      });
                    }}/>
                  </div>
                  <h2 className={hideThree ? "active" : ""}>€ {summary?.net_transaction}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5>All Transactions</h5>
              <div className="filter d-flex align-items-center">
                <div className="dropdown">
                  <button className="flex align-items-center">
                    <span>Sort</span>
                    <img src={sort} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleSort("customer__name")}>Name <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-customer__name")}>Name <TiArrowSortedUp/></li>
                      <li onClick={() => handleSort("transaction_date")}>Date <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-transaction_date")}>Date <TiArrowSortedUp/></li>
                      <li onClick={() => handleSort("balance")}>Balance <TiArrowSortedDown/></li>
                      <li onClick={() => handleSort("-balance")}>Balance <TiArrowSortedUp/></li>
                    </ul>
                  </div>
                </div>
                <div className="dropdown" style={{marginLeft:"10px"}}>
                  <button className="flex align-items-center">
                    <span>Accounts</span>
                    <img src={filter} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleAccounts("")}>All</li>
                      <li onClick={() => handleAccounts("credit")}>Credit</li>
                      <li onClick={() => handleAccounts("debit")}>Debit</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive dashboard-tbl">
              <Table className="dashboard table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer" }}>Date</th>
                    <th style={{ cursor: "pointer" }}>Customer</th>
                    <th style={{ cursor: "pointer" }}>Details</th>
                    <th style={{ cursor: "pointer" }}>Debit & Credit</th>
                    <th style={{ cursor: "pointer" }}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.map((user, index) => (
                      <tr key={index}>
                        <td>{moment(user.transaction_date).format('DD/MM/YYYY')}</td>
                        <td>{user.customer__name}</td>
                        <td className="detail-td">
                          {user.details}
                        </td>
                        <td className={user.transaction_type === 'debit' ? "green" : "red"} style={{whiteSpace: "nowrap"}}>
                          € {user.transaction_amount} {user.transaction_type === 'debit' ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
                        </td>
                        <td>€ {user.balance || "00.00"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
              <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
                <div className="text-muted small">
                  {(currentPage - 1) * itemsPerPage + 1}-
                  {10*(currentPage - 1) + filteredCustomers.length}
                  {/* {Math.min(
                    currentPage * itemsPerPage,
                    filteredCustomers.length
                  )}{" "} */}
                  {" "}of {pageInfo.total_data || "0"}
                </div>
                <div className="d-flex align-items-center">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="itemsPerPage">Rows per page:</label>
                    <select
                      id="itemsPerPage"
                      className="form-control"
                      value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <MdOutlineKeyboardArrowDown />
                  </div>
                  <Pagination size="sm" className="pagination-rounded mb-0">
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    <p>
                      <span>{currentPage}</span>/{pageInfo.total_pages}
                    </p>
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === pageInfo.total_pages}
                    />
                  </Pagination>
                </div>
              </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
